<template>
  <div>
    <h2>Enneagram</h2>
    <v-form ref="enneagramForm">
      <v-container>
        <v-row>
          <v-col>
            <v-switch
              id="js-enneagram-hidden-toggle"
              class="mr-2"
              v-model="visibleValue"
              label="Visible"
            ></v-switch>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field
              class="js-primary-type"
              v-model="primaryValue"
              label="First Score"
              :rules="enneagramRules"
            ></v-text-field>
          </v-col>

          <v-col>
            <v-text-field
              class="js-secondary-type"
              v-model="secondaryValue"
              label="Second Score"
              :rules="enneagramRules"
            ></v-text-field>
          </v-col>

          <v-col>
            <v-text-field
              class="js-tertiary-type"
              v-model="tertiaryValue"
              label="Third Score"
              :rules="enneagramRules"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-text-field
              class="js-selected-type"
              v-model="selectedValue"
              label="Selected Type"
              :rules="enneagramRules"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row justify="space-around">
          <v-btn
            class="ma-4"
            id="js-add-enneagram-button"
            color="secondary"
            @click="updateEnneagram()"
            large
          >
            Add Enneagram Results Data
          </v-btn>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import eventMixin from "@/mixins/eventMixin"

export default {
  mixins: [eventMixin],
  props: {
    userId: { type: Number },
    primaryType: { type: String },
    secondaryType: { type: String },
    tertiaryType: { type: String },
    selectedType: { type: String },
    visible: { type: Boolean }
  },
  watch: {
    primaryType: function(newVal, oldVal) {
      this.primaryValue = newVal
    },
    secondaryType: function(newVal, oldVal) {
      this.secondaryValue = newVal
    },
    tertiaryType: function(newVal, oldVal) {
      this.tertiaryValue = newVal
    },
    selectedType: function(newVal, oldVal) {
      this.selectedValue = newVal
    },
    visible: function(newVal, oldVal) {
      this.visibleValue = newVal
    }
  },
  data: function() {
    return {
      primaryValue: "",
      secondaryValue: "",
      tertiaryValue: "",
      selectedValue: "",
      visibleValue: false,
      enneagramRules: [
        v =>
          v === null ||
          (/[1-9]/.test(v) && v.length < 2) ||
          v.length == 0 ||
          "Values 1-9 Only"
      ]
    }
  },
  created() {
    this.primaryValue = this.primaryType
    this.secondaryValue = this.secondaryType
    this.tertiaryValue = this.tertiaryType
    this.selectedValue = this.selectedType
    this.visibleValue = this.visible
  },
  methods: {
    updateEnneagram() {
      if (this.$refs.enneagramForm.validate()) {
        this.fireEvent("enneagram_result:add", {
          userId: this.userId,
          primaryType: this.primaryValue,
          secondaryType: this.secondaryValue,
          tertiaryType: this.tertiaryValue,
          selectedType: this.selectedValue,
          visible: this.visibleValue
        })
      } else {
        console.log("not updating because form did not validate")
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";
@import "../../scss/buttons";
</style>
